import { registerPlugin } from '@capacitor/core';

import { CAPACITOR_MULTI_FORMAT_CLIPBOARD_PLUGIN } from '../pluginConstants';
import { withBridgedStackTrace } from '../withBridgedStackTrace';
import type { MultiFormatClipboardPlugin } from './definitions';

const MultiFormatClipboardRaw = registerPlugin<MultiFormatClipboardPlugin>(CAPACITOR_MULTI_FORMAT_CLIPBOARD_PLUGIN);
const MultiFormatClipboard = withBridgedStackTrace(MultiFormatClipboardRaw, CAPACITOR_MULTI_FORMAT_CLIPBOARD_PLUGIN);

export * from './definitions';
export { MultiFormatClipboard };
